import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';

@Component({
  selector: 'app-selecao-analise',
  templateUrl: './selecao-analise.page.html',
  styleUrls: ['./selecao-analise.page.scss'],
})
export class SelecaoAnalisePage implements OnInit {




  categorias = [];

  categoriasAux = [];

  formCatId;
   // tslint:disable-next-line: max-line-length
  constructor(private router: Router, private route: ActivatedRoute, private toast: ToastService, private apiproduto: ProdutoapiService) { }

  ngOnInit() {
  }



  async ranking() {
    try {
      this.router.navigate(['/dados-ranking']);
    } catch (error) {
      this.toast.showError('Ocorreu um erro');
      console.log(error);
    }

  }


  
  async ociosos() {
    try {
      this.router.navigate(['/dados-ociosos']);
    } catch (error) {
      this.toast.showError('Ocorreu um erro');
      console.log(error);
    }

  }


}
